export enum MailTag {
  BackupArchive = 'BackupArchive',
  DateTo = 'DateTo',
  DateFrom = 'DateFrom',
  From = 'From',
  Size = 'Size',
  SizeFilter = 'Filter',
  SizeLess = 'SizeLess',
  SizeMagnitude = 'Magnitude',
  SizeMore = 'SizeMore',
  SizeValue = 'Value',
  Subject = 'Subject',
  To = 'To',
  WithAttachment = 'WithAttachments'
}

export const MailTagsMap = new Map<MailTag, { tag: string; prop: string }>([
  [MailTag.From, { tag: 'From', prop: 'From' }],
  [MailTag.To, { tag: 'To', prop: 'To' }],
  [MailTag.SizeMore, { tag: 'Size more than', prop: 'Size' }],
  [MailTag.SizeLess, { tag: 'Size less than', prop: 'Size' }],
  [MailTag.Subject, { tag: 'Subject', prop: 'Subject' }],
  [MailTag.WithAttachment, { tag: 'With attachments', prop: 'HasAttach' }],
  [MailTag.BackupArchive, { tag: 'Backup archive', prop: 'IsArchived' }],
  [MailTag.DateTo, { tag: 'To date', prop: 'ReceiveDate' }],
  [MailTag.DateFrom, { tag: 'Date from', prop: 'ReceiveDate' }]
]);
